import React, {useMemo} from 'react'
import {Button, Icon, Label, Loading, Modal} from '@therms/atalaya'
import {RPCDocs, useLocationLogEntryTypesByIds} from '@therms/react-modules'
import {groupBy} from 'lodash-es'
import {getColorContrast} from '@therms/web-js'
import {LocationLogsUserAnPGeoConditional} from '../../LocationLogsUserAnPGeoConditional'
import {RiFileEditFill} from 'react-icons/ri'

interface Props {
  closeHandler: () => void
  entryTypeIds: string[]
  onSelectEntryType: (entryTypeId: string, entryTypeName: string) => void
}

function SelectLocationLogEntryTypeModal({
  closeHandler,
  entryTypeIds,
  onSelectEntryType,
}: Props) {
  const {data: entryTypesData, loading: entryTypesDataLoading} =
    useLocationLogEntryTypesByIds({
      entryTypeIds,
      pagination: {limit: 100},
    })

  const entryTypesCategoryDouble = useMemo<
    [string, RPCDocs.Locations.GetLocationLogEntryTypesList.v1.EntryType[]][]
  >(() => {
    if (!entryTypesData?.entryTypes) return [] as any

    const grouped = groupBy(entryTypesData.entryTypes, 'category')

    return Object.entries(grouped).sort((a, b) => (a[0] > b[0] ? -1 : 1))
  }, [entryTypesData])

  return (
    <Modal closeHandler={closeHandler} escPressClose header="Pick Entry Type">
      {entryTypesDataLoading && !entryTypesCategoryDouble?.length && (
        <Loading message="Loading Entry Types" overlay />
      )}

      <LocationLogsUserAnPGeoConditional>
        {entryTypesCategoryDouble.map(([category, entryTypes]) => (
          <div className="gap-y-base mt-3 flex flex-col" key={category}>
            <Label>{category}</Label>

            <div className="gap-lg grid grid-cols-3">
              {entryTypes.map((entryType) => (
                <Button
                  key={entryType.id}
                  onClick={() =>
                    onSelectEntryType(entryType.id, entryType.name)
                  }
                  style={{
                    backgroundColor: entryType.color,
                    color: getColorContrast(entryType.color),
                  }}
                  className="py-base"
                >
                  {entryType.name}
                </Button>
              ))}
            </div>
          </div>
        ))}

        {!entryTypesCategoryDouble?.length && (
          <div className="flex h-full grow flex-col items-center opacity-50">
            <Icon
              Icon={RiFileEditFill}
              color="neutral"
              className="h-[100px] w-[100px]"
            />
            <span className="text-center text-lg font-medium capitalize">
              No Entry Types
            </span>
          </div>
        )}
      </LocationLogsUserAnPGeoConditional>
    </Modal>
  )
}

export {SelectLocationLogEntryTypeModal}
